import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { ElectionContextProviderService } from "@shared/services/election-context-provider.service";

export const electionContextGuard: CanActivateFn = (next: ActivatedRouteSnapshot, _: RouterStateSnapshot): boolean => {
  const electionContextProviderService = inject(ElectionContextProviderService);
  electionContextProviderService.electionId = next.params['electionId'];

  if (electionContextProviderService.electionId) {
    return true;
  }
  return false;
};
